export const trackGA4Event = ({ category, action, label, value }) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', action || category, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
};

export const trackConversion = (
  conversionId,
  label,
  value = 0,
  currency = 'USD',
  transaction_id = ''
) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      send_to: `${conversionId}/${label}`,
      value,
      currency,
      transaction_id
    });
  } else {
    console.warn('gtag not initialized');
  }
};

export function identifyUser(user) {
  if (!window.cioanalytics) return;

  window.cioanalytics.identify(user.id, {
    email: user.email,
    name: user.fullName,
    plan: user.accountType
  });
}

export function trackPage(path) {
  if (!window.analytics) return;
  window.analytics.page(path, {
    url: window.location.href,
    title: document.title
  });
}

export function trackCioEvent(eventName, properties = {}) {
  if (!window.cioanalytics) return;

  window.cioanalytics.track(eventName, properties);
}
